import { ReactComponent as ColumnAddComment } from 'Shared/assets/icons/add-comment.svg'
import { ReactComponent as AddContact } from 'Shared/assets/icons/add-contact.svg'
import { ReactComponent as Admin } from 'Shared/assets/icons/admin.svg'
import { ReactComponent as Analytic } from 'Shared/assets/icons/analytic.svg'
import { ReactComponent as ArrowDown } from 'Shared/assets/icons/arrow-down.svg'
import { ReactComponent as ArrowDownSmall } from 'Shared/assets/icons/arrow-down-small.svg'
import { ReactComponent as ArrowDropdown } from 'Shared/assets/icons/arrow-dropdown.svg'
import { ReactComponent as ArrowRight } from 'Shared/assets/icons/arrow-right.svg'
import { ReactComponent as ArrowUp } from 'Shared/assets/icons/arrow-up.svg'
import { ReactComponent as AttachFile } from 'Shared/assets/icons/attach-file.svg'
import { ReactComponent as Audit } from 'Shared/assets/icons/audit.svg'
import { ReactComponent as Bell } from 'Shared/assets/icons/bell.svg'
import { ReactComponent as BlueCheck } from 'Shared/assets/icons/blue-check.svg'
import { ReactComponent as BrandLogo } from 'Shared/assets/icons/brand-logo.svg'
import { ReactComponent as Check } from 'Shared/assets/icons/check.svg'
import { ReactComponent as CircleExclamationWarning } from 'Shared/assets/icons/circle-exclamation-warning.svg'
import { ReactComponent as CircleSuccess } from 'Shared/assets/icons/circle-success.svg'
import { ReactComponent as CircleSuccessFilled } from 'Shared/assets/icons/circle-success-filled.svg'
import { ReactComponent as CircleWarning } from 'Shared/assets/icons/circle-warning.svg'
import { ReactComponent as CircleWarningGray } from 'Shared/assets/icons/circle-warning-gray.svg'
import { ReactComponent as Close } from 'Shared/assets/icons/close.svg'
import { ReactComponent as CloseCircle } from 'Shared/assets/icons/close-circle.svg'
import { ReactComponent as Collapse } from 'Shared/assets/icons/collapse.svg'
import { ReactComponent as ColumnComment } from 'Shared/assets/icons/column-comment.svg'
import { ReactComponent as ColumnSolidComment } from 'Shared/assets/icons/column-solid-comment.svg'
import { ReactComponent as Comment } from 'Shared/assets/icons/comment.svg'
import { ReactComponent as Company } from 'Shared/assets/icons/company.svg'
import { ReactComponent as Copy } from 'Shared/assets/icons/copy.svg'
import { ReactComponent as CopyClipboard } from 'Shared/assets/icons/copy-clipboard.svg'
import { ReactComponent as CustomerInvoice } from 'Shared/assets/icons/customer-invoice.svg'
import { ReactComponent as Customers } from 'Shared/assets/icons/customers.svg'
import { ReactComponent as Dashboard } from 'Shared/assets/icons/dashboard.svg'
import { ReactComponent as DatePicker } from 'Shared/assets/icons/date-picker.svg'
import { ReactComponent as Document } from 'Shared/assets/icons/document.svg'
import { ReactComponent as DownloadFile } from 'Shared/assets/icons/download-file.svg'
import { ReactComponent as DragSource } from 'Shared/assets/icons/dragSource.svg'
import { ReactComponent as Ellipse } from 'Shared/assets/icons/ellipse.svg'
import { ReactComponent as Email } from 'Shared/assets/icons/email.svg'
import { ReactComponent as Error } from 'Shared/assets/icons/error.svg'
import { ReactComponent as ErrorSolid } from 'Shared/assets/icons/errorSolid.svg'
import { ReactComponent as ExpandedLeft } from 'Shared/assets/icons/expandedLeft.svg'
import { ReactComponent as ExpandedRight } from 'Shared/assets/icons/expandedRight.svg'
import { ReactComponent as Explore } from 'Shared/assets/icons/explore.svg'
import { ReactComponent as Eye } from 'Shared/assets/icons/eye.svg'
import { ReactComponent as FAQ } from 'Shared/assets/icons/faq.svg'
import { ReactComponent as FilledCircleWarning } from 'Shared/assets/icons/filled-circle-warning.svg'
import { ReactComponent as FilledWarning } from 'Shared/assets/icons/filled-warning.svg'
import { ReactComponent as Filter } from 'Shared/assets/icons/filter.svg'
import { ReactComponent as FullScreen } from 'Shared/assets/icons/fullscreen.svg'
import { ReactComponent as Graphic } from 'Shared/assets/icons/graphic.svg'
import { ReactComponent as HelpCenter } from 'Shared/assets/icons/help-center.svg'
import { ReactComponent as History } from 'Shared/assets/icons/history.svg'
import { ReactComponent as Invoice } from 'Shared/assets/icons/invoice.svg'
import { ReactComponent as Item } from 'Shared/assets/icons/item.svg'
import { ReactComponent as Learning } from 'Shared/assets/icons/learning.svg'
import { ReactComponent as LearningWord } from 'Shared/assets/icons/learning-word.svg'
import { ReactComponent as Location } from 'Shared/assets/icons/location.svg'
import { ReactComponent as Logo } from 'Shared/assets/icons/logo.svg'
import { ReactComponent as Logout } from 'Shared/assets/icons/logout.svg'
import { ReactComponent as Map } from 'Shared/assets/icons/map.svg'
import { ReactComponent as Minus } from 'Shared/assets/icons/minus.svg'
import { ReactComponent as NoData } from 'Shared/assets/icons/no-data.svg'
import { ReactComponent as NotFoundContent } from 'Shared/assets/icons/not-found-content.svg'
import { ReactComponent as Open } from 'Shared/assets/icons/open.svg'
import { ReactComponent as Order } from 'Shared/assets/icons/order.svg'
import { ReactComponent as OrderList } from 'Shared/assets/icons/order-list.svg'
import { ReactComponent as Payment } from 'Shared/assets/icons/payment.svg'
import { ReactComponent as PercentageSign } from 'Shared/assets/icons/percentage-sign.svg'
import { ReactComponent as Phone } from 'Shared/assets/icons/phone.svg'
import { ReactComponent as PinServiceSitePrimary } from 'Shared/assets/icons/pinServiceSitePrimary.svg'
import { ReactComponent as PinServiceSitePrimaryInactive } from 'Shared/assets/icons/pinServiceSitePrimaryInactive.svg'
import { ReactComponent as PinServiceSiteSecondary } from 'Shared/assets/icons/pinServiceSiteSecondary.svg'
import { ReactComponent as PinServiceSiteSecondaryRestricted } from 'Shared/assets/icons/pinServiceSiteSecondaryRestricted.svg'
import { ReactComponent as PinSupplierPrimary } from 'Shared/assets/icons/pinSupplierPrimary.svg'
import { ReactComponent as PinSupplierPrimaryInactive } from 'Shared/assets/icons/pinSupplierPrimaryInactive.svg'
import { ReactComponent as PinSupplierSecondary } from 'Shared/assets/icons/pinSupplierSecondary.svg'
import { ReactComponent as PinSupplierSecondaryRestricted } from 'Shared/assets/icons/pinSupplierSecondaryRestricted.svg'
import { ReactComponent as Plus } from 'Shared/assets/icons/plus.svg'
import { ReactComponent as Processing } from 'Shared/assets/icons/processing.svg'
import { ReactComponent as Profile } from 'Shared/assets/icons/profile.svg'
import { ReactComponent as PurchaseOrder } from 'Shared/assets/icons/purchase-order.svg'
import { ReactComponent as Regulatory } from 'Shared/assets/icons/regulatory.svg'
import { ReactComponent as Reload } from 'Shared/assets/icons/reload.svg'
import { ReactComponent as Report } from 'Shared/assets/icons/report.svg'
import { ReactComponent as Revert } from 'Shared/assets/icons/revert.svg'
import { ReactComponent as Search } from 'Shared/assets/icons/search.svg'
import { ReactComponent as SelectClose } from 'Shared/assets/icons/select-close.svg'
import { ReactComponent as ServiceOccurrence } from 'Shared/assets/icons/service-occurrence.svg'
import { ReactComponent as ServiceSiteFilter } from 'Shared/assets/icons/service-site-filter.svg'
import { ReactComponent as ServiceSiteFilterInactive } from 'Shared/assets/icons/service-site-filter-inactive.svg'
import { ReactComponent as Share } from 'Shared/assets/icons/share.svg'
import { ReactComponent as SmallWarning } from 'Shared/assets/icons/smallWarning.svg'
import { ReactComponent as Sort } from 'Shared/assets/icons/sort.svg'
import { ReactComponent as StarActive } from 'Shared/assets/icons/star-active.svg'
import { ReactComponent as StarDefault } from 'Shared/assets/icons/star-default.svg'
import { ReactComponent as Storage } from 'Shared/assets/icons/storage.svg'
import { ReactComponent as SupplierFilter } from 'Shared/assets/icons/supplier-filter.svg'
import { ReactComponent as SupplierFilterInactive } from 'Shared/assets/icons/supplier-filter-inactive.svg'
import { ReactComponent as SupplierInvoice } from 'Shared/assets/icons/supplier-invoice.svg'
import { ReactComponent as Suppliers } from 'Shared/assets/icons/suppliers.svg'
import { ReactComponent as TableColumnFilter } from 'Shared/assets/icons/table-column-filter.svg'
import { ReactComponent as Trash } from 'Shared/assets/icons/trash.svg'
import { ReactComponent as Unlock } from 'Shared/assets/icons/unlock.svg'
import { ReactComponent as UnlockCircle } from 'Shared/assets/icons/unlock-circle.svg'
import { ReactComponent as UploadDocument } from 'Shared/assets/icons/upload-document.svg'
import { ReactComponent as UserLocation } from 'Shared/assets/icons/userLocation.svg'
import { ReactComponent as Warning } from 'Shared/assets/icons/warning.svg'
import { ReactComponent as WarningCircle } from 'Shared/assets/icons/warning-circle.svg'
import { ReactComponent as WarningKey } from 'Shared/assets/icons/warning-key.svg'
import { ReactComponent as WarningSolid } from 'Shared/assets/icons/warningSolid.svg'
import { ReactComponent as WavingHand } from 'Shared/assets/icons/waving-hand.svg'

const Icons = {
	purchaseOrder: PurchaseOrder,
	addContact: AddContact,
	arrowDropdown: ArrowDropdown,
	arrowDown: ArrowDown,
	arrowUp: ArrowUp,
	arrowRight: ArrowRight,
	analytic: Analytic,
	close: Close,
	collapse: Collapse,
	logo: Logo,
	company: Company,
	customerInvoice: CustomerInvoice,
	dashboard: Dashboard,
	datePicker: DatePicker,
	helpCenter: HelpCenter,
	email: Email,
	item: Item,
	open: Open,
	order: Order,
	plus: Plus,
	processing: Processing,
	admin: Admin,
	profile: Profile,
	report: Report,
	search: Search,
	serviceOccurrence: ServiceOccurrence,
	sort: Sort,
	customers: Customers,
	suppliers: Suppliers,
	logout: Logout,
	supplierInvoice: SupplierInvoice,
	warning: Warning,
	warningSolid: WarningSolid,
	trash: Trash,
	attachFile: AttachFile,
	starActive: StarActive,
	starDefault: StarDefault,
	reload: Reload,
	check: Check,
	ellipse: Ellipse,
	comment: Comment,
	circleWarning: CircleWarning,
	percentageSign: PercentageSign,
	uploadDocument: UploadDocument,
	unlock: Unlock,
	storage: Storage,
	smallWarning: SmallWarning,
	document: Document,
	filledWarning: FilledWarning,
	circleSuccess: CircleSuccess,
	unlockCircle: UnlockCircle,
	revert: Revert,
	regulatory: Regulatory,
	notFoundContent: NotFoundContent,
	circleWarningGray: CircleWarningGray,
	warningKey: WarningKey,
	noData: NoData,
	brandLogo: BrandLogo,
	wavingHand: WavingHand,
	invoice: Invoice,
	selectClose: SelectClose,
	filter: Filter,
	orderList: OrderList,
	copy: Copy,
	warningCircle: WarningCircle,
	filledCircleWarning: FilledCircleWarning,
	blueCheck: BlueCheck,
	downloadFile: DownloadFile,
	closeCircle: CloseCircle,
	faq: FAQ,
	phone: Phone,
	circleExclamationWarning: CircleExclamationWarning,
	minus: Minus,
	eye: Eye,
	circleSuccessFilled: CircleSuccessFilled,
	graphic: Graphic,
	audit: Audit,
	dragSource: DragSource,
	payment: Payment,
	bell: Bell,
	pinSupplierSecondary: PinSupplierSecondary,
	fullScreen: FullScreen,
	location: Location,
	pinSupplierPrimary: PinSupplierPrimary,
	error: Error,
	errorSolid: ErrorSolid,
	pinSupplierSecondaryRestricted: PinSupplierSecondaryRestricted,
	pinServiceSitePrimary: PinServiceSitePrimary,
	pinServiceSiteSecondary: PinServiceSiteSecondary,
	pinServiceSiteSecondaryRestricted: PinServiceSiteSecondaryRestricted,
	userLocation: UserLocation,
	map: Map,
	serviceSiteFilter: ServiceSiteFilter,
	serviceSiteFilterInactive: ServiceSiteFilterInactive,
	supplierFilter: SupplierFilter,
	supplierFilterInactive: SupplierFilterInactive,
	tableColumnFilter: TableColumnFilter,
	columnComment: ColumnComment,
	columnSolidComment: ColumnSolidComment,
	columnAddComment: ColumnAddComment,
	pinServiceSitePrimaryInactive: PinServiceSitePrimaryInactive,
	pinSupplierPrimaryInactive: PinSupplierPrimaryInactive,
	learning: Learning,
	learningWord: LearningWord,
	copyClipboard: CopyClipboard,
	arrowDownSmall: ArrowDownSmall,
	history: History,
	expandedRight: ExpandedRight,
	expandedLeft: ExpandedLeft,
	explore: Explore,
	share: Share
}

export default Icons
